import BigNumber from 'bignumber.js';

/**
 * Adapted from
 * @see https://github.com/tradeparadigm/mono/blob/release/paradex-1.29.3/api/paradex/prototype/utility_functions.py#L152
 */
export default function cubic_real_solution(
  a0: BigNumber,
  b0: BigNumber,
  c0: BigNumber,
  d0: BigNumber,
): BigNumber {
  // find real solution for the cubic equation (a0*x^3)+(b0*x^2)+(c0*x)+d=0
  // using Cardano's method https://brilliant.org/wiki/cardano-method/
  if (a0.isEqualTo(0)) {
    throw new Error('a0 cannot be 0');
  }
  const b = b0.dividedBy(a0);
  const c = c0.dividedBy(a0);
  const d = d0.dividedBy(a0);
  // Q = ((3 * c) - (b**2)) / 9
  const Q = BigNumber(3).times(c).minus(b.pow(2)).dividedBy(9);
  // R = ((9 * b * c) - (27 * d) - 2 * (b**3)) / 54
  const R = BigNumber(9)
    .times(b)
    .times(c)
    .minus(BigNumber(27).times(d))
    .minus(BigNumber(2).times(b.pow(3)))
    .dividedBy(54);
  // assert (Q**3) + (R**2) >= 0
  if (Q.pow(3).plus(R.pow(2)).isLessThan(0)) {
    throw new Error(
      'cubic_real_solution: Q**3 + R**2 must be greater than or equal to 0',
    );
  }
  // U = ((Q**3) + (R**2)).sqrt()
  const U = Q.pow(3).plus(R.pow(2)).sqrt();

  const S = R.plus(U);
  const S_POW = BigNumber(Math.cbrt(S.toNumber()));

  const T = R.minus(U);
  const T_POW = BigNumber(Math.cbrt(T.toNumber()));

  return S_POW.plus(T_POW).minus(b.dividedBy(3));
}
